import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const OrderSuccess = () => {
  const loc = useLocation();
  const order = loc.state?.order;
  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-24 text-center">
      <CheckCircle2 className="h-16 w-16 text-[#2c6e49] mx-auto mb-4" />
      <h1 className="font-heading text-3xl font-bold text-[#2c1e12]">Order confirmed!</h1>
      <p className="text-[#8a7458] mt-1">Your order number is</p>
      <p className="font-heading text-2xl font-bold text-[#9a4a2f] mt-1">{order.order_number}</p>

      <div className="mt-5 rounded-2xl bg-[#f6ece0] p-4 text-left">
        <p className="text-sm text-[#6b5844]">{order.fulfillment_type === "delivery" ? "Delivery" : "Pickup"} on <strong>{order.fulfillment_date}</strong></p>
        <div className="mt-3 space-y-1">
          {order.items.map((it, i) => (
            <div key={i} className="flex justify-between text-sm text-[#2c1e12]">
              <span>{it.qty} × {it.name}</span>
              <span>${(it.price * it.qty).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-[#e6d8bf] mt-3 pt-3 flex justify-between font-bold text-[#2c1e12]">
          <span>Total</span><span>${order.total.toFixed(2)}</span>
        </div>
        {order.points_earned > 0 && <p className="text-sm text-[#2c6e49] mt-2">You earned {order.points_earned} reward points!</p>}
      </div>

      <p className="text-sm text-[#8a7458] mt-4">A confirmation email is on its way to you.</p>
      <Link to="/menu" className="mt-5 inline-flex rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold px-6 py-3 transition-colors">Order More</Link>
    </div>
  );
};

export default OrderSuccess;
